<template>
  <NuxtLayout
    name="generic"
    header="standardDark"
    footer="standard"
  >
    <div
      :class="{
        'blog-template mt-70px bg-www-color-neutral-off-white md:mt-120px': true,
        'max-md:[&>p.content]:text-sm': true,
      }"
    >
      <template v-if="data">
        <BreadCrumbFromRoute
          :class="{
            'hero-container': true,
          }"
          :title="data.title"
        />

        <BlogHero :blog-hero="data.blogHero" />

        <PortableText
          v-if="data.content.blogPortableText"
          :class="{
            'p-0 text-www-color-neutral-medium-dark': true,
          }"
          :portable-data="data?.content.blogPortableText"
        />

        <CTABanner
          v-if="data.CTABanner?.reference"
          :data="data.CTABanner.reference"
        />

        <SuggestedContent
          v-if="!data.removeSuggestedContent"
          :suggested-title="data.suggestedContentTitle"
          :current-id="data._id"
          page-type="blog"
        />
      </template>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { queryBlog } from '~/queries/pages/PageBlog.query';
import type { QueryBlogResult } from '~/sanity/types';
import BreadCrumbFromRoute from '~/components/Atoms/BreadCrumb/BreadCrumbFromRoute.vue';
import BlogHero from '~/components/Organisms/BlogHero/BlogHero.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';
import SuggestedContent from '~/components/Organisms/SuggestedContent/SuggestedContent.vue';
import { extractAbstractFromPortableText } from '~/utils/extractBreakoutSummary';

const { path: currentPathname } = useRoute();
const { data } = await useWwwSanityQueryNonNull<QueryBlogResult>(queryBlog, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  author: data.value?.blogHero.person?.reference?.name,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  dateModified: data.value?._updatedAt,
  datePublished: data.value?.articleDate,
  authorImage: data.value?.blogHero.person?.reference?.headshot,
  structuredData: [
    {
      schemaType: 'BlogPosting',
      title: data.value?.htmlTitle || data.value?.title,
      description: data.value?.ogDescription || data.value?.description,
      contentSummary: data.value?.description,
      abstract: extractAbstractFromPortableText(data.value?.content?.blogPortableText),
      imageRef: data.value?.ogImage?.asset?._ref || data.value?.cardImage?.asset?._ref,
      authorName: data.value?.blogHero.person?.reference?.name,
      dateModified: data.value?._updatedAt,
      datePublished: data.value?.articleDate,
      articleSection: data.value?.blogHero.taxonomies?.[0]?.prefLabel,
      keywords: data.value?.blogHero.taxonomies?.map((taxonomy) => taxonomy.prefLabel),
      enabled: true,
    },
  ],
});
</script>
